import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Container } from 'reactstrap';
import { injectIntl } from 'react-intl';

import {
  APIgetRoles,
  APIdeleteRole,
} from '../../api/Roles';

import { showConfirmationModal } from '../../actions/App';

import AdminRolesHeader from '../../components/Admin/Roles/Header';
import AdminRolesList from '../../components/Admin/Roles/List';
import AdminRolesFooter from '../../components/Admin/Roles/Footer';
import EmptyCustomRoles from '../EmptyContainers/CustomRoles';
import TrialNotice from '../../components/TrialNotice';

import { getVisibleItemsText } from '../../helpers';
import { getUserSetting } from '../../helpers/Settings';
import {
  handleComponentParams,
  handleURLParams,
} from '../../helpers/URLParams';

import ErrorBoundary from '../../components/ErrorBoundary';
import HelpIcon from '../../components/HelpIcon';
import Loading from '../../components/Loading';

class AdminRoles extends Component {
  constructor(props) {
    super(props);

    this.state = {
      roles: [],
      rolesTotal: 0,
      page: 1,
      perPage: getUserSetting('admin_per_page') || 20,
      orderBy: 'name',
      order: 'asc',
      loading: true,
    };

    this.handleChangeOrder = this.handleChangeOrder.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangePerPage = this.handleChangePerPage.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.loadRoles = this.loadRoles.bind(this);
  }

  componentDidUpdate(prevProps) {
    handleComponentParams(
      false,
      ['page', 'perPage', 'orderBy', 'order'],
      prevProps,
      this.setState.bind(this),
      () => this.loadRoles(),
      { orderBy: 'name', order: 'asc', perPage: getUserSetting('admin_per_page') || 20 },
    );
  }

  componentDidMount() {
    const { history, location } = this.props;
    const { orderBy, order } = this.state;
    const queryParams = new URLSearchParams(location.search);

    handleComponentParams(
      true,
      ['page', 'perPage', 'orderBy', 'order'],
      null,
      this.setState.bind(this),
      () => this.loadRoles(),
      { orderBy: 'name', order: 'asc', perPage: getUserSetting('admin_per_page') || 20 },
    );

    if (!queryParams.get('orderBy')) {
      handleURLParams({ orderBy }, history);
    }

    if (!queryParams.get('order')) {
      handleURLParams({ order }, history);
    }
  }

  loadRoles() {
    const {
      page,
      perPage,
      orderBy,
      order,
    } = this.state;

    this.setState({ loading: true });

    APIgetRoles({
      page,
      per_page: perPage,
      order_by: orderBy,
      order,
    }).then((response) => {
      const { data } = response;
      if (data) {
        this.setState({
          loading: false,
          roles: data.data,
          rolesTotal: data.meta.total,
        });
      }
    });
  }

  handleChangeOrder(orderBy, order) {
    const { history } = this.props;
    handleURLParams({ orderBy, order, page: 1 }, history);

    this.setState({
      orderBy,
      order,
      page: 1,
    });
  }

  handleChangePage(page) {
    const { history } = this.props;
    handleURLParams({ page }, history);

    this.setState({
      page,
    });
  }

  handleChangePerPage(perPage) {
    const { history } = this.props;
    handleURLParams({ perPage, page: 1 }, history);

    this.setState({ perPage, page: 1 });
  }

  handleDelete(role) {
    const { deleteRole } = this.props;

    deleteRole(role, this.loadRoles);
  }

  render() {
    const {
      intl,
    } = this.props;
    const {
      page,
      perPage,
      rolesTotal,
      loading,
    } = this.state;

    return (
      <div className="settings-inner-content">
        <div className="main-content">
          <Container fluid>
            <AdminRolesHeader
              rolesTotal={rolesTotal}
              rolesVisible={getVisibleItemsText(page, perPage, rolesTotal)}
              loading={loading}
            />
            <TrialNotice feature="custom-roles" className="pl-0" />
            {rolesTotal > 0 && (
              <p>
                {intl.formatMessage({ defaultMessage: 'Create Custom Roles to assign additional capabilities to your users based on need.' })}
                <HelpIcon
                  id="help-custom-roles"
                  url="https://help.stockpress.co/en/articles/5937840-creating-custom-user-roles"
                />
              </p>
            )}
            {loading ? (
              <Loading />
            ) : (
              <>
                {rolesTotal > 0 ? (
                  <>
                    <ErrorBoundary>
                      <AdminRolesList
                        {...this.state}
                        handleChangeOrder={this.handleChangeOrder}
                        handleDelete={this.handleDelete}
                      />
                    </ErrorBoundary>
                    <ErrorBoundary>
                      <AdminRolesFooter
                        {...this.state}
                        handleChangePage={this.handleChangePage}
                        handleChangePerPage={this.handleChangePerPage}
                      />
                    </ErrorBoundary>
                  </>
                ) : (
                  <EmptyCustomRoles link="/admin/settings/roles/add" />
                )}
              </>
            )}
          </Container>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  deleteRole: (role, loadRoles) => {
    const { intl } = props;
    const modalParams = {
      title: intl.formatMessage({ defaultMessage: 'Are you sure?' }),
      text: intl.formatMessage({ defaultMessage: 'Are you sure you want to delete this Custom Role? This action can not be undone. If you have users associated with this Custom Role, they will become default users.' }),
      onConfirm: () => (
        APIdeleteRole(role.id).then(() => {
          loadRoles();
        })
      ),
    };
    dispatch(showConfirmationModal(modalParams));
  },
});

AdminRoles.propTypes = {
  intl: PropTypes.object.isRequired,
  deleteRole: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default withRouter(injectIntl(connect(null, mapDispatchToProps)(AdminRoles)));
